<div style="padding: 0px" title="">
  <div class="panel-wrapper">
    <sm-card
      *ngIf="panelType != 'transparent'"
      [icon]="showIcon ? icon : null"
      [iconSecondary]="iconSecondary"
      [title]="title != '' ? title : null"
      [desc]="subtitle"
      (onDblClick)="toggleCollapse()"
      [count]="!(badgeText == '' || badgeText == '0') ? badgeText : null"
      [badgeColor]="badgeColor"
      [allowCollapse]="allowCollapse"
      [collapsed]="collapsed"
    >
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </sm-card>
    <div *ngIf="panelType == 'transparent'" style="background-color: transparent">
      <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    </div>
    <ng-template #contentTemplate>
      <div
        #panelContent
        [style.display]="collapsed ? 'none' : ''"
        [style.min-height]="_minBodyHeightFormula"
        ngbTooltip=""
      >
        <ng-content></ng-content>
      </div>
    </ng-template>
  </div>
</div>
